var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExitRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 640 640"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 528V144c0-26.467 21.533-48 48-48h320c26.467 0 48 21.533 48 48v128c0 8.836-7.164 16-16 16s-16-7.164-16-16V144c0-8.822-7.178-16-16-16H48c-8.822 0-16 7.178-16 16v384c0 8.822 7.178 16 16 16h320c8.822 0 16-7.178 16-16V400c0-8.837 7.164-16 16-16s16 7.163 16 16v128c0 26.467-21.533 48-48 48H48c-26.467 0-48-21.533-48-48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M523.313 443.312l96-96c6.249-6.248 6.249-16.379 0-22.627l-96-96c-6.248-6.249-16.379-6.249-22.627 0s-6.249 16.379 0 22.627L569.373 320H208c-8.837 0-16 7.164-16 16s7.163 16 16 16h361.373l-68.686 68.688C497.562 423.811 496 427.905 496 432s1.562 8.189 4.687 11.312c6.248 6.25 16.378 6.25 22.626 0z"
  })));
}

export default SvgExitRight;